import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 py-1 px-2 sm:py-2 sm:px-4 border-t border-gray-700">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-1 md:mb-0 text-gray-400 text-center md:text-left text-xs sm:text-sm">
          <p>© {new Date().getFullYear()} Melbourne School Zone Property Finder. All data is for informational purposes only.</p>
          <p className="mt-0 sm:mt-1">Made with ❤️ locally in Melbourne.</p>
        </div>
        
        <div className="flex items-center mt-1 sm:mt-0">
          <a 
            href="https://www.buymeacoffee.com/datafun" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-1 px-2 sm:py-2 sm:px-4 rounded-md flex items-center text-xs sm:text-sm"
          >
            <span className="mr-1 sm:mr-2">☕</span>
            Buy Me a Coffee
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;